export const TYPE_CREATE_DIALOG = 'dialog/CREATE_DIALOG';
export const TYPE_DISMISS_DIALOG = 'dialog/DISMISS_DIALOG';
